import { render, staticRenderFns } from "./refundGoods.vue?vue&type=template&id=7a88ab94&scoped=true&"
import script from "./refundGoods.vue?vue&type=script&lang=js&"
export * from "./refundGoods.vue?vue&type=script&lang=js&"
import style0 from "./refundGoods.vue?vue&type=style&index=0&id=7a88ab94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a88ab94",
  null
  
)

export default component.exports